import React, { Fragment, useEffect,useState } from "react";
import PropTypes from "prop-types";
import HeadSection from "./HeadSection1";
import Pcards from "./Pcards";
import {Box, Button, Typography} from '@mui/material';
import { Link } from "react-router-dom";
import StatVisit from "../../../shared/functions/statVisit";
import Categories from "./categories";
import ResponsiveFeatures from "./features";
import { useMediaQuery } from "@mui/material";
import GoogleReviews from "./googleRewievs";


function Home(props) {
  const { selectHome ,data, types} = props;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Mobil kontrol

  useEffect(() => {
    selectHome();
  }, [selectHome]);


  const favdata=[...data].sort((a,b)=> b.fav - a.fav)
  StatVisit('Home')
  return (
    <Fragment>
      <HeadSection/>
      {isMobile ? <ResponsiveFeatures array={0}/>:<ResponsiveFeatures array={-1}/>}
      <Categories></Categories>
      {isMobile && <ResponsiveFeatures array={1}/>}
      <Pcards data={data.slice(0,4)} name='Uusimmat Tuotteet' ismenu={true} types={types}/>
          <Box width='100%' justifyContent="center" display='flex' >
          <Link
          key='kt1'
          to='/products' >
            <Button variant='contained' color='error'sx={{ mt:'5vh'}}>
            <Typography  variant='h7'>Kaikki Tuotteet</Typography>
            </Button>
          </Link>
          </Box>
          {isMobile && <ResponsiveFeatures array={2}/>}
      <Pcards data={favdata.slice(0,3)} name='Suosikki Tuotteet' ismenu={true} types={types}/>
        <Box width='100%' display='flex' justifyContent="center" >
        <Link
          key='kt1'
          to='/products' >
            <Button variant='contained' color='error' sx={{ mt:'5vh'}}>
            <Typography  variant='h7'>Kaikki Tuotteet</Typography>
            </Button>
        </Link>
        </Box>
      { favdata.filter(el => el.sale.indexOf('%') >-1).length >0 &&
      <Pcards data={favdata.filter(el => el.sale.indexOf('%') >-1)} name='Alennettu Tuotteet' ismenu={true} types={types}/>
      }
      {isMobile && <ResponsiveFeatures array={3}/>}
      <GoogleReviews></GoogleReviews>
    </Fragment>
  );
}

Home.propTypes = {
  selectHome: PropTypes.func.isRequired
};

export default Home;

